import { Roles, Status, ContractTypes } from "app/models/user"
import { FilterActionResult } from "../filter/filter.actions"
import createFilterReducer, { DEFAULT_STATE, FilterableEntities } from "../filter/filter.reducer"

export type UserFilter = {
  [k: string]: string[] | string | undefined
  functions: string[]
  status: string | undefined
  roles: string[]
  q: string | undefined
  contract_type: ContractTypes | undefined
}

const INITIAL_STATE = {
  ...DEFAULT_STATE,
  filterableFields: {
    functions: [],
    status: [Status.Active, Status.Inactive],
    roles: [Roles.Planner, Roles.HROfficer, Roles.User],
    contract_type: [ContractTypes.PAYROLL, ContractTypes.EXTERNAL],
  },
  filters: { functions: [], status: undefined, roles: [], q: undefined, contract_type: undefined },
}

const usersFilterReducer = (state = INITIAL_STATE, action: FilterActionResult<UserFilter>) =>
  createFilterReducer<UserFilter>(FilterableEntities.Users)(state, action)

export default usersFilterReducer
